import { render, staticRenderFns } from "./SidebarSubmenu.vue?vue&type=template&id=3bb0de28&scoped=true&"
import script from "./SidebarSubmenu.vue?vue&type=script&lang=js&"
export * from "./SidebarSubmenu.vue?vue&type=script&lang=js&"
import style0 from "./SidebarSubmenu.vue?vue&type=style&index=0&id=3bb0de28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb0de28",
  null
  
)

export default component.exports